"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftPurchaseTransactionToJSON = exports.NftPurchaseTransactionFromJSONTyped = exports.NftPurchaseTransactionFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function NftPurchaseTransactionFromJSON(json) {
    return NftPurchaseTransactionFromJSONTyped(json, false);
}
exports.NftPurchaseTransactionFromJSON = NftPurchaseTransactionFromJSON;
function NftPurchaseTransactionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return __assign(__assign({}, (0, _1.NftSaleConfigLineItemFromJSONTyped)(json, ignoreDiscriminator)), { 'transactionHash': !(0, runtime_1.exists)(json, 'transactionHash') ? undefined : json['transactionHash'], 'nftMintTransaction': !(0, runtime_1.exists)(json, 'nftMintTransaction') ? undefined : json['nftMintTransaction'], 'contractAddress': !(0, runtime_1.exists)(json, 'contractAddress') ? undefined : json['contractAddress'], 'chain': !(0, runtime_1.exists)(json, 'chain') ? undefined : (0, _1.EVMChainFromJSON)(json['chain']), 'nftOwnerships': !(0, runtime_1.exists)(json, 'nftOwnerships') ? undefined : json['nftOwnerships'] });
}
exports.NftPurchaseTransactionFromJSONTyped = NftPurchaseTransactionFromJSONTyped;
function NftPurchaseTransactionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return __assign(__assign({}, (0, _1.NftSaleConfigLineItemToJSON)(value)), { 'transactionHash': value.transactionHash, 'nftMintTransaction': value.nftMintTransaction, 'contractAddress': value.contractAddress, 'chain': (0, _1.EVMChainToJSON)(value.chain), 'nftOwnerships': value.nftOwnerships });
}
exports.NftPurchaseTransactionToJSON = NftPurchaseTransactionToJSON;
